import humanizeDuration from "humanize-duration";
import { useState } from "react";

import { useInterval } from "@intelligems/ig-utils";
import { Grid, Typography } from "@mui/material";
import { Theme } from "@mui/material/styles";
import { SxProps } from "@mui/system";

import { ColorWarning } from "./theme";

interface IgLastUpdatedTextProps {
  compareTimeMs: number;
  typographySx?: SxProps<Theme>;
  noPrefix?: boolean;
}

export function IgLastUpdatedText({
  compareTimeMs,
  typographySx,
  noPrefix,
}: IgLastUpdatedTextProps) {
  const [now, setNow] = useState(Date.now());

  useInterval(() => {
    setNow(Date.now());
  }, 31 * 1000);

  const getCompareTime = () => {
    const diff = now - compareTimeMs;
    return diff < 30 * 1000
      ? `${noPrefix ? "" : "Last updated: "}just now`
      : `${noPrefix ? "" : "Last updated:"} ${
          humanizeDuration(diff, { maxDecimalPoints: 0 }).split(", ")[0]
        } ago`;
  };

  return (
    <Grid item>
      <Typography
        sx={{ ...typographySx }}
        fontWeight={500}
        variant={"h6"}
        color={ColorWarning.info}
        lineHeight={1.3}
      >
        {getCompareTime()}
      </Typography>
    </Grid>
  );
}
